import { Card } from "primereact/card"
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useOutletContext } from "react-router-dom";
import { useState, type CSSProperties } from "react";

const AboutUs = ({ t, aboutUsdialogVisible, setAboutUsdialogVisible }: any) => {
    // const { t }: any = useOutletContext();
    const lang = localStorage.getItem("i18nextLng") === "en" ? "en-US" : "tr-TR";
    const [ifuDialogVisible, setIfuDialogVisible] = useState(false);
    const currentManualLink = lang === "en-US"
        ? "https://firebasestorage.googleapis.com/v0/b/mobithera-ef0d4.firebasestorage.app/o/Pdfs%2Fen%2FInstructions_for_use_en.pdf?alt=media&token=d7556ba8-91aa-4e0c-a847-a992c2d48a07"
        : "https://firebasestorage.googleapis.com/v0/b/mobithera-ef0d4.firebasestorage.app/o/Pdfs%2Ftr%2FInstructions_for_use_tr.pdf?alt=media&token=d7556ba8-91aa-4e0c-a847-a992c2d48a07";

    const ifuHistory = [
        {
            status: t("revision"),
            ifuVersion: "04",
            iosVersion: "3.16.0 - 3.23.0",
            androidVersion: "3.16.0 - 3.23.0",
            webVersion: "4.0.0",
            revisionDate: "17.04.2026",
        },
        {
            status: t("revision"),
            ifuVersion: "03",
            iosVersion: "3.16.0",
            androidVersion: "3.16.0",
            webVersion: "4.0.0",
            revisionDate: "24.07.2025",
        },
        {
            status: t("revision"),
            ifuVersion: "02",
            iosVersion: "3.15.1",
            androidVersion: "3.15.1",
            webVersion: "4.0.0",
            revisionDate: "22.07.2025",
        },
        {
            status: t("revision"),
            ifuVersion: "01",
            iosVersion: "3.10.3",
            androidVersion: "3.8.13",
            webVersion: "-",
            revisionDate: "07.04.2025",
        },
        {
            status: t("firstRelease"),
            ifuVersion: "00",
            iosVersion: "3.10.3",
            androidVersion: "3.8.13",
            webVersion: "-",
            revisionDate: "10.01.2025",
        },
    ];

    const thStyle: CSSProperties = {
        textAlign: "left",
        padding: "0.85rem 1rem",
        fontSize: "0.85rem",
        fontWeight: 600,
        color: "#2D3967",
        whiteSpace: "nowrap",
    };

    const tdStyle: CSSProperties = {
        padding: "0.85rem 1rem",
        fontSize: "0.85rem",
        color: "#7279A1",
        whiteSpace: "nowrap",
    };

    return (
        <>
            <Dialog
                header={t("aboutUsHeader")}
                visible={aboutUsdialogVisible}
                draggable={false}
                style={{ width: '80vw', borderRadius: '24px', overflow: "hidden" }}
                onHide={() => setAboutUsdialogVisible(false)} blockScroll>

                <p className="m-0 text-md" style={{ color: "#727A99" }}>{t("aboutUsDescription")}</p>

                <br />

                <div className="flex align-items-start justify-content-between gap-4 w-full">
                    <div className="flex flex-column  w-full">
                        <div className="flex align-items-center gap-2">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/mdIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> {t("medicalDevice")}</p>
                                <p className="m-0 text-md" style={{ color: "#727A99" }}>{t("mobitheraClassified")}</p>
                            </div>
                        </div>
                        <div className="flex align-items-center gap-2">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/companyIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> {t("mobitheraCompany")}</p>
                                <p className="m-0 text-md" style={{ color: "#727A99" }}>{t("address")}</p>
                            </div>
                        </div>

                        <div className="flex align-items-center gap-2">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/udiIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>

                            <div className="flex align-items-center w-full gap-2">
                                <div style={{ width: "3.6rem", height: "5rem" }} className="flex align-items-center justify-content-center">
                                    <img src="/barcode410.jpg" style={{ width: "100%", height: "100%", objectFit: "contain", marginTop: "0.2rem" }} />
                                </div>
                                <p className="m-0 text-md" style={{ color: "#727A99" }}>(01)08684917043125 <br />(8012)4.1.0</p>
                            </div>
                        </div>

                        <div className="flex align-items-center gap-2">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/refIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> MOB.03</p>
                                <p className="m-0 text-md" style={{ color: "#727A99" }}>{t("MobitheraWebApplication")}</p>
                            </div>
                        </div>

                    </div>


                    <div className="flex flex-column gap-2 w-full">
                        <div className="flex align-items-center gap-1">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/instructionsIcon.png" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                            </div>
                            <div className="flex flex-column w-full">
                                <p className="text-lg m-0 font-bold" style={{ color: "#2D3967" }}> {t("clickForUserManual")}</p>
                            <p
                                onClick={() => {
                                    setAboutUsdialogVisible(false);
                                    setIfuDialogVisible(true);
                                }}
                                className="m-0 text-md cursor-pointer hover:text-blue-500 " style={{ color: "#727A99" }}>{t("downloadInstructions")}</p>
                            </div>
                        </div>

                        <div className="flex align-items-center">
                            <div style={{ width: "7rem", height: "7rem" }} className="flex align-items-center justify-content-center">
                                <img src="/ce-mark.jpeg" style={{ width: "100%", height: "100%", objectFit: "contain", marginRight: "1rem" }} />
                            </div>
                        </div>

                        <div className="flex align-items-center">
                            <div className="flex flex-column w-full  mt-2">
                                <p className="text-md m-0 font-bold" style={{ color: "#2D3967" }}> {t("softwareVersion")}: <span className="font-normal" style={{ color: "#727A99" }}>4.1.0</span></p>
                                <p className="m-0 text-md font-bold" style={{ color: "#2D3967" }}>{t("versionReleaseDate")}: <span className="font-normal" style={{ color: "#727A99" }}>14.08.2026</span></p>

                            </div>
                        </div>

                        <div className="flex align-items-center justify-content-end mt-8">


                            <p className="m-0 text-md " style={{ color: "#2D3967" }}>LB.01/00</p>

                        </div>
                    </div>

                </div>
            </Dialog>

            <Dialog
                header={t("informationForUse")}
                visible={ifuDialogVisible}
                draggable={false}
                style={{ width: "60vw", borderRadius: "24px", overflow: "hidden" }}
                onHide={() => setIfuDialogVisible(false)}
                blockScroll
            >
                <div className="flex flex-column gap-4">
                    <div className="flex flex-column gap-2 w-full">
                        <div className="flex align-items-center gap-1">
                            <span className="text-sm font-semibold line-height-1" style={{ color: "#2D3967" }}>
                                {t("current")}:
                            </span>
                            <a
                                href={currentManualLink}
                                target="_blank"
                                rel="noreferrer"
                                className="text-sm font-medium hover:underline line-height-1"
                                style={{ color: "#4C6FFF" }}
                            >
                                {t("clickForUserManual")}
                            </a>
                        </div>
                        <div className="flex align-items-center justify-content-between gap-2 w-full white-space-nowrap" style={{ overflowX: "auto" }}>
                            <div className="flex align-items-center gap-1 flex-shrink-0">
                                <span className="text-sm font-semibold line-height-1" style={{ color: "#2D3967" }}>
                                    {t("ifuVersion")}:
                                </span>
                                <span className="text-sm line-height-1" style={{ color: "#4C6FFF" }}>05</span>
                            </div>
                            <div className="flex align-items-center gap-1 flex-shrink-0">
                                <span className="text-sm font-semibold line-height-1" style={{ color: "#2D3967" }}>
                                    {t("revisionDate")}:
                                </span>
                                <span className="text-sm line-height-1" style={{ color: "#4C6FFF" }}>20.08.2026</span>
                            </div>
                            <div className="flex align-items-center gap-1 flex-shrink-0">
                                <span className="text-sm font-semibold line-height-1" style={{ color: "#2D3967" }}>
                                    {t("iosVersion")}:
                                </span>
                                <span className="text-sm line-height-1" style={{ color: "#4C6FFF" }}>3.26.0</span>
                            </div>
                            <div className="flex align-items-center gap-1 flex-shrink-0">
                                <span className="text-sm font-semibold line-height-1" style={{ color: "#2D3967" }}>
                                    {t("androidVersion")}:
                                </span>
                                <span className="text-sm line-height-1" style={{ color: "#4C6FFF" }}>3.26.0</span>
                            </div>
                            <div className="flex align-items-center gap-1 flex-shrink-0">
                                <span className="text-sm font-semibold line-height-1" style={{ color: "#2D3967" }}>
                                    {t("webVersion")}:
                                </span>
                                <span className="text-sm line-height-1" style={{ color: "#4C6FFF" }}>4.1.0</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex flex-column gap-2 w-full">
                        <span className="text-base font-semibold" style={{ color: "#2D3967" }}>
                            {t("history")}
                        </span>
                        <div style={{ border: "1px solid #EEF0F6", borderRadius: "12px", overflow: "hidden" }}>
                            <div style={{ overflowX: "auto" }}>
                                <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "40rem" }}>
                                    <thead>
                                        <tr style={{ background: "#F4F6FB" }}>
                                            <th style={thStyle}>{t("status")}</th>
                                            <th style={thStyle}>{t("ifuVersion")}</th>
                                            <th style={thStyle}>{t("revisionDate")}</th>
                                            <th style={thStyle}>{t("iosVersion")}</th>
                                            <th style={thStyle}>{t("androidVersion")}</th>
                                            <th style={thStyle}>{t("webVersion")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ifuHistory.map((row, index) => (
                                            <tr
                                                key={index}
                                                style={{ borderTop: "1px solid #EEF0F6" }}
                                            >
                                                <td style={tdStyle}>{row.status}</td>
                                                <td style={tdStyle}>{row.ifuVersion}</td>
                                                <td style={tdStyle}>{row.revisionDate}</td>
                                                <td style={tdStyle}>{row.iosVersion}</td>
                                                <td style={tdStyle}>{row.androidVersion}</td>
                                                <td style={tdStyle}>{row.webVersion}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div
                        className="flex flex-wrap align-items-center justify-content-between gap-3 p-3"
                        style={{ background: "#EEF1FA", borderRadius: "12px" }}
                    >
                        <div className="flex align-items-center gap-3" style={{ flex: 1, minWidth: "18rem" }}>
                            <div
                                className="flex align-items-center justify-content-center flex-shrink-0"
                                style={{
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    borderRadius: "50%",
                                    backgroundColor: "#2336A1",
                                }}
                            >
                                <i className="pi pi-info" style={{ color: "#FFFFFF", fontSize: "0.8rem" }} />
                            </div>
                            <p className="m-0 text-sm" style={{ color: "#2336A1" }}>
                                {t("ifuSupportInfo")}
                            </p>
                        </div>
                        <Button
                            className="p-button-outlined"
                            label={t("contactSupport")}
                            icon={<img src="/call-center.svg" alt="" style={{ width: "1.35rem", height: "1.35rem", marginRight: "0.35rem" }} />}
                            onClick={() => window.open("https://web.whatsapp.com/send?phone=905301595673", "_blank")}
                            style={{
                                color: "#2336A1",
                                borderColor: "#2336A1",
                                backgroundColor: "transparent",
                                borderRadius: "10px",
                                whiteSpace: "nowrap",
                                gap: "0.35rem",
                            }}
                        />
                    </div>
                </div>
            </Dialog>
        </>
    )
}


export default AboutUs